<!-- 
    描述：添加评分设置
    时间：2022-5-19 10:08:58
    Created by 钱磊
-->
<template>
  <div class="filed-info-layout">
    <div class="common-top">
      <el-form
        :model="addForm"
        label-width="130px"
        :rules="rules"
        size="medium"
        ref="addForm"
      >
        <el-form-item label="规则名称：" prop="sname">
          <el-input
            v-model.trim="addForm.sname"
            placeholder="请输入规则名称"
            :maxlength="50"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="评价应用：" prop="applyBus">
          <el-select
            v-model="addForm.applyBus"
            placeholder="请选择评价应用"
            clearable
          >
            <el-option
              v-for="(item, index) in yyyw"
              :key="index"
              :label="item.sname"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="评价维度：" prop="assItems">
          <el-checkbox-group v-model="addForm.assItems">
            <el-checkbox
              v-for="(item, index) in pjwd"
              :key="index"
              :label="item.value"
              >{{ item.sname }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="单项分值：" prop="singleScore">
          <img src="@/assets/images/rateValue.png" alt="" />
          <span class="ml20">总分：<span class="total-rate">5</span>分</span>
          <el-input
            placeholder="请输入内容"
            v-model="addForm.singleScore"
            size="small"
            disabled
          >
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button
            type="primary"
            plain
            size="medium"
            @click="saveAssessRule('0')"
            :loading="btnLoading"
            >暂保存</el-button
          >
          <el-button
            type="success"
            plain
            size="medium"
            @click="saveAssessRule('1')"
            :loading="btnLoading"
            >立即生效</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { saveAssessRule } from "api/modules/assessment-system/AssessmentSetting";
export default {
  props: {},
  data() {
    return {
      addForm: {
        sname: "", //规则名称
        applyBus: "", //评价应用
        assItems: [], //评价项目
        singleScore: "1", //单项分值
        totalScore: "5", //单项总分
        ruleStatus: "0", //启用状态
      },
      btnLoading: false,
      rules: {
        sname: [{ required: true, message: "请输入规则名称", trigger: "blur" }],
        applyBus: [
          { required: true, message: "请选择评价应用", trigger: "change" },
        ],
        assItems: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个评价维度",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    // 如果是编辑下 有数据 直接回显
    if (this.routeQuery === "edit") {
      let params = JSON.parse(this.$getSessionItem("evaluateInfo"));
      console.log(params);
      this.addForm.sname = params.sname;
      this.addForm.applyBus = params.applyBus;
      this.addForm.assItems = params.assItems.split(",");
      this.addForm.id = params.id;
    }
  },
  methods: {
    // 评价规则保存
    saveAssessRule(val) {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let params = this.$utils.clone(this.addForm, true);
          params.assItems = this.addForm.assItems.join(",");
          params.ruleStatus = val;
          if (this.routeQuery === "edit") {
            params.updatedUserid = this.userInfo.id;
          } else {
            params.createUserid = this.userInfo.id;
            params.createUser = this.userInfo.sname;
          }
          if (val == "1") {
            //判断是暂保存还是立即启用
            let applyBus = this.yyyw.filter((item) => {
              return item.value == params.applyBus;
            });
            let yyyw = applyBus[0].sname;
            this.$confirm(
              "请确定开启配置，开启后" + yyyw + "项目评价将会被更新！",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                this.saveRules(params);
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
                this.btnLoading = false;
              });
          } else {
            this.saveRules(params);
            setTimeout(() => {
              this.btnLoading = false;
            }, 2000);
          }
        } else {
          this.$message.warning("请校验表单是否填写完整！");
          setTimeout(() => {
            this.btnLoading = false;
          }, 2000);
        }
      });
    },
    // 评价规则保存方法
    saveRules(params) {
      saveAssessRule(params)
        .then((res) => {
          if (res.operationCode === 1) {
            this.$message.success("操作成功！");
            this.btnLoading = false;
            setTimeout(() => {
              this.$router.push({ path: "/assessment-setting" });
              this.$emit("close");
            }, 500);
          }
        })
        .catch((err) => {
          setTimeout(() => {
            this.btnLoading = false;
          }, 2000);
        });
    },
  },
  computed: {
    routeQuery() {
      return this.$route.query.type;
    },
    ...mapState("dict", {
      yyyw: (state) => state.yyyw,
      pjwd: (state) => state.pjwd,
    }),
    ...mapState("user", {
      userInfo: (state) => state.userInfo,
    }),
  },
};
</script>
<style lang='less' scoped>
.filed-info-layout {
  .common-top {
    padding: 20px 0;
    width: 600px;
    .el-checkbox {
      display: block;
    }
    .total-rate {
      color: #0000ff;
    }
  }
}
</style>

